<!-- src/app/forgot-password/forgot-left/forgot-left.component.html -->
<div class="left-panel">
  <!-- Back to Login Link -->
  <div class="back-to-login">
    <a (click)="goToLogin()" class="back-link">
      <svg class="back-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 19l-7-7m0 0l7-7m-7 7h18"
        />
      </svg>
      <span>Back to Login</span>
    </a>
  </div>

  <!-- Step 1 -->
  @if (stage === 1) {
    <div class="step">
      <h1 class="step-title">Reset your password</h1>
      <p class="muted step-description">
        Forgot your password? Please enter your Email, and we'll send 4-digit code.
      </p>

      <form [formGroup]="emailForm" (ngSubmit)="requestOtp()" class="email-form">
        <div class="form-field">
          <input
            type="email"
            formControlName="email"
            placeholder="Enter Email Address"
            class="text-input"
          />
        </div>

        <button type="submit" class="btn" [disabled]="loading">
          {{ loading ? 'Sending...' : 'Submit' }}
        </button>
      </form>
    </div>
  }

  <!-- Step 2 -->
  @if (stage === 2) {
    <div class="step">
      <h3 class="step-title">Enter confirmation code</h3>
      <p class="muted step-description">
        We sent a code to <span class="email-text">{{ svc.current.email }}</span>
      </p>

      <div class="otp-row">
        <input
          #otpInput
          type="text"
          maxlength="1"
          (input)="onOtpInput($event, 0)"
          (keydown)="onOtpKeydown($event, 0)"
        />
        <input
          #otpInput
          type="text"
          maxlength="1"
          (input)="onOtpInput($event, 1)"
          (keydown)="onOtpKeydown($event, 1)"
        />
        <input
          #otpInput
          type="text"
          maxlength="1"
          (input)="onOtpInput($event, 2)"
          (keydown)="onOtpKeydown($event, 2)"
        />
        <input
          #otpInput
          type="text"
          maxlength="1"
          (input)="onOtpInput($event, 3)"
          (keydown)="onOtpKeydown($event, 3)"
        />
      </div>

      <div class="actions">
        <button class="btn btn-center" (click)="verifyOtp()" [disabled]="loading">
          {{ loading ? 'Verifying...' : 'Continue' }}
        </button>
        <div class="resend-container">
          <a
            class="link"
            [class.disabled]="!canResend"
            (click)="canResend && resendOtp()"
            [style.pointer-events]="canResend ? 'auto' : 'none'"
            [style.opacity]="canResend ? '1' : '0.6'"
          >
            @if (resendTimer > 0) {
              <span>Resend code in {{ timerDisplay }}</span>
            }
            @if (resendTimer === 0) {
              <span>Resend code</span>
            }
          </a>
        </div>
      </div>
    </div>
  }

  <!-- Step 3 -->
  @if (stage === 3) {
    <div class="step">
      <h3 class="step-title">Create a new password</h3>
      <p class="muted step-description">
        Please choose a password that hasn't been used before. Must be at least 8 characters.
      </p>

      <form [formGroup]="passwordForm" (ngSubmit)="submitPassword()" class="password-form">
        <div class="form-field">
          <input
            type="password"
            formControlName="password"
            placeholder="Set new password"
            class="text-input"
          />
        </div>
        <div class="form-field">
          <input
            type="password"
            formControlName="confirm"
            placeholder="Confirm new password"
            class="text-input"
          />
        </div>

        <button type="submit" class="btn" [disabled]="loading">
          {{ loading ? 'Processing...' : 'Continue' }}
        </button>
      </form>
    </div>
  }

  <!-- Step 4 -->
  @if (stage === 4) {
    <div class="step">
      <h2 class="step-title">Password Reset !</h2>
      <p class="muted step-description two-line">
        Your password has been successfully reset.<br />
        Click below to login.
      </p>
      <button class="btn" (click)="continueFromSuccess()">Continue</button>
    </div>
  }
</div>
